import React, { Component } from "react";
import COLORS from "scss/colors.module.scss";
import { FaExpandArrowsAlt } from "react-icons/fa";

import { DIMENSIONS } from "utils/Dimensions";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

export default class MultiLineColumnEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.getDefaultValue(props) || "",
      editorModal: false,
      canEdit : window.appStore?.containerStore?.permissions?.canEdit(props?.colDef?.cellRendererParams?.columnId, props?.data)[0],
      canAddColumn : window.appStore?.containerStore?.permissions?.canAddColumn(props?.colDef?.cellRendererParams?.columnId, props?.data)[0],
      canAdd : window.appStore?.containerStore?.permissions?.canAdd(),
      isValidRowId : this.props?.node?.data?.row_id !== "" && this.props?.node?.data?.row_id !== "+"
    };
    this.arrowKeyNavigation = this.arrowKeyNavigation.bind(
      this
    );
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  getDefaultValue(props) {
    return props.charPress ? props.charPress : props.value;
  }

  handleChange = (value) => {
    if(this.state.canEdit === false && (this.state.canAdd === false || (this.state.canAdd === true && this.state.isValidRowId)) || (this.state.canAddColumn === false && !this.state.isValidRowId)) return;
    if(this.props.colDef.store.isLazyLoadEnabled) {
      this.props.colDef.store.isCurrentRowSaving = true;
    }
    this.props.onChange(value);
    this.setState({ value: value });
  };

  componentDidMount() {
    this.refs.container.addEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
    this.focus();
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    this.refs.container.removeEventListener(
      "keydown",
      this.arrowKeyNavigation
    );
   try {
      this.refs.container.offsetParent.style.bottom = "";
    } catch (e) {}
  }

  getColIds = () => {
    var nextColId = "",
      prevColId = "",
      columnDefs = this.props?.columnApi?.columnController?.columnDefs;
    for (let i = 0; i < columnDefs.length; i++) {
      if (columnDefs[i]["colId"] === this.props.colDef.colId) {
        nextColId =
          columnDefs[i + 1 === columnDefs.length - 1 ? i : i + 1]["colId"];
        prevColId = columnDefs[i - 1 < 0 ? i : i - 1]["colId"];
        break;
      }
    }
    return { nextColId: nextColId, prevColId: prevColId };
  };

  async arrowKeyNavigation(event) {
    if ([13].indexOf(event.keyCode) > -1) {
      event.stopPropagation();
    }
    if (event.shiftKey && event.code === "Enter") {
      this.focusNextCell();
    }
  }

  focusNextCell = (
    rowIndex = this.props.rowIndex + 1,
    colId = this.props.column.colId
  ) => {
    this.props.api.clearRangeSelection();
    this.props.api.stopEditing();
    this.props.colDef.store.addRowOnGrid(
      rowIndex,
      this.props.node.id,
      this.props.context,
      colId
    );
    setTimeout(()=>{
      this.props.api.setFocusedCell(rowIndex, colId);
    },10)
  };

  focus() {
    window.setTimeout(() => {
      if (this.refs.textArea) {
        this.refs.textArea.focus();
        this.refs.textArea.value = "";
        this.refs.textArea.value = this.state.value;
        document.addEventListener("mousedown", this.handleClickOutside);
      }
    }, 10);
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target) && !this.state.editorModal) {
      const focusedCell = this.props.api.getFocusedCell();
      document.removeEventListener("mousedown", this.handleClickOutside);
      this.props.api.stopEditing(false);
      if (this.props.rowIndex === focusedCell.rowIndex && this.props.column.colId === focusedCell.column.colId) {
        window.setTimeout(()=>{
          this.focusNextCell(this.props.rowIndex, this.props.column.colId)
        },200)
      }
    }
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  getValue() {
    return this.state.value;
  }

  isPopup() {
    return false;
  }

  render() {
    return (
      <div ref={this.setWrapperRef} style={{ height: "150px" }}>
        <div ref="container" className="multiLineContainer">
          <textarea
            ref="textArea"
            value={this.state.value}
            disabled={this.state.canEdit === false && (this.state.canAdd === false || (this.state.canAdd === true && this.state.isValidRowId)) || (this.state.canAddColumn === false && !this.state.isValidRowId)}
            className="mlEditor"
            style={{
              ...styles.input,
              width: Number(this.props.colDef.width) - 5,
              height: DIMENSIONS.multiline_expanded_height - 5,
            }}
            onChange={(e) => {
              this.handleChange(e.target.value);
            }}
          />
          { (this.state.canEdit || (this.state.canAdd && !this.state.isValidRowId) || (this.state.canAddColumn === false && !this.state.isValidRowId)) && <StyledFixedDiv className="multiLineExtraText">Shift+Enter or Tab to save</StyledFixedDiv> }
          <div
            className="expandArrow"
            style={{ position: "absolute", right: 5, top: 5, lineHeight: "1.5em" }}
            onClick={() => {
              this.setState({ editorModal: true });
            }}
          >
            <FaExpandArrowsAlt size={14} />
          </div>
          <Dialog
            fullWidth={true}
            maxWidth={"xs"}
            open={this.state.editorModal}
            onClose={() => {
              this.setState({ editorModal: false });
            }}
            aria-labelledby="form-dialog-title"
          >
            <DialogContent>
              <textarea
                ref="textArea"
                value={this.state.value}
                style={{
                  ...styles.input,
                  ...styles.modalTextArea,
                  width: "100%",
                  height: window.innerHeight / 3,
                }}
                disabled={this.state.canEdit === false && (this.state.canAdd === false || (this.state.canAdd === true && this.state.isValidRowId)) || (this.state.canAddColumn === false && !this.state.isValidRowId)}
                onChange={(e) => {
                  this.handleChange(e.target.value);
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  this.setState({ editorModal: false });
                }}
                color="primary"
              >
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

const styles = {
  input: {
    paddingLeft: 10,
    paddingRight: 25,
    backgroundColor: COLORS.PRIMARY_COLOR,
    resize: "none",
    lineHeight: "1.5em",
    fontSize: 13,
    color: COLORS.TEXT_COLOR,
    fontFamily: "Roboto, sans-serif",
  },
  modalTextArea: {
    borderColor: COLORS.MULTI_LINE_MODAL_BORDER,
    outline: "none",
  },
};

const StyledFixedDiv = styled.div`
  position: sticky;
  background-color: #fff;
  bottom: 0px;
  padding-bottom: 0px !important; 
  padding-top: 0px !important;
  `;